import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
    content: {
        background: '#f5f5f5'
    },
}))